import { render, staticRenderFns } from "./InputTipoCliente.vue?vue&type=template&id=6b01128c&"
import script from "./InputTipoCliente.vue?vue&type=script&lang=ts&"
export * from "./InputTipoCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports